module.exports = __webpack_public_path__ + "static/media/cuddle.e90d923c.gif";